var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddWidgetPlacement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 124,
    viewBox: "0 0 117 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 65.5,
    r: 56,
    stroke: "#E7E7E7",
    strokeOpacity: 0.42,
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.8182 88.2273V43.2273H61.4545V88.2273H53.8182ZM35.1364 69.5455V61.9091H80.1364V69.5455H35.1364Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWidgetPlacement);
export default __webpack_public_path__ + "static/media/add_widget_placement.2f66110e8e105dbc588b018efce05a35.svg";
export { ForwardRef as ReactComponent };